// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"Top50Results_groupTitle__DTXFp","showAll":"Top50Results_showAll__16v4F"};